"use strict";
/**
 * Header component to show the project name and allow editing.
 * Supports projects in either lab2 or legacy lab mode.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var projectRedux_1 = require("../../projectRedux");
var EditProjectName_1 = __importDefault(require("./EditProjectName"));
var DisplayProjectName_1 = __importDefault(require("./DisplayProjectName"));
var Lab2Registry_1 = __importDefault(require("@cdo/apps/lab2/Lab2Registry"));
var EditableProjectName = function (_a) {
    var onChangedWidth = _a.onChangedWidth;
    var _b = (0, react_1.useState)(false), editName = _b[0], setEditName = _b[1];
    var legacyProjectName = (0, react_redux_1.useSelector)(function (state) { return state.project.projectName; });
    var lab2ProjectName = (0, react_redux_1.useSelector)(function (state) { var _a; return (_a = state.lab.channel) === null || _a === void 0 ? void 0 : _a.name; });
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useLayoutEffect)(function () {
        if (onChangedWidth) {
            onChangedWidth();
        }
    });
    function beginEdit() {
        setEditName(true);
    }
    function finishEdit() {
        setEditName(false);
        if (!Lab2Registry_1.default.hasEnabledProjects()) {
            dispatch((0, projectRedux_1.refreshProjectName)());
        }
    }
    function saveProjectName(newName) {
        var _a;
        if (Lab2Registry_1.default.hasEnabledProjects()) {
            return (_a = Lab2Registry_1.default.getInstance().getProjectManager()) === null || _a === void 0 ? void 0 : _a.rename(newName);
        }
        else {
            return dashboard.project.rename(newName);
        }
    }
    var projectName = Lab2Registry_1.default.hasEnabledProjects()
        ? lab2ProjectName || ''
        : legacyProjectName;
    if (editName) {
        return (react_1.default.createElement(EditProjectName_1.default, { finishEdit: finishEdit, projectName: projectName, saveProjectName: saveProjectName }));
    }
    else {
        return (react_1.default.createElement(DisplayProjectName_1.default, { beginEdit: beginEdit, projectName: projectName }));
    }
};
exports.default = EditableProjectName;
